import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import FieldSelectorMenuTrigger from './FieldSelectorMenuTrigger';

import styles from '../styles/index';

const useStyles = createUseStyles(styles, 'MenuOptions');

const MenuOptions = memo(({ fieldSelector, fieldSelectorProps, tooltipMenuContent }) => {
    const classes = useStyles();

    if (!fieldSelector) return null;

    return (
        <FieldSelectorMenuTrigger
            className={classes.fieldSelector}
            fieldSelectorProps={fieldSelectorProps}
            tooltipMenuContent={tooltipMenuContent}
        />
    );
});

export default MenuOptions;
